import { TranslateModule } from '../../../shared/translate/translate.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { ConditionDetailsComponent } from './condition-details.component';

@NgModule({
  imports: [CommonModule, IonicModule, TranslateModule],
  declarations: [ConditionDetailsComponent],
  exports: [ConditionDetailsComponent]
})
export class ConditionDetailsModule { }
